import { CacheKey } from './cache-key.enum';

/** Lançada por `CacheEntry.read` quando a chave não existe mais ou o TTL já passou. */
export class CacheExpiredError extends Error {
  constructor(key: CacheKey) {
    super(`Cache expirado ou inexistente para a chave "${key}".`);
    this.name = 'CacheExpiredError';
  }
}
